import { render, staticRenderFns } from "./Relatie.vue?vue&type=template&id=d6c025be"
import script from "./Relatie.vue?vue&type=script&lang=js"
export * from "./Relatie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports